<div class="modal-dialog hey-gen-prompt-editor">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="heygen-editor"></h4>
      <button type="button" class="close-btn" (click)="cancel()" aria-label="Cancel">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      @for (prompt of prompts; track prompt; let i = $index) {
        <div class="prompt">
          <span class="number">{{i}}</span>
          <span class="title">{{prompt.promptName}}</span>
          <button class="edit" type="button" (click)="edit(prompt)">Edit</button>
          <button class="delete" type="button" (click)="remove(prompt)">Delete</button>
        </div>
      }
    </div>
    <div class="goreact-modal-footer">
      <button class="secondary-btn" (click)="cancel()" translate="common_cancel" data-cy="common_cancel"></button>
      <button class="primary-btn" (click)="create()" translate="common_add" data-cy="common_add"></button>
      <button class="primary-btn" (click)="save()" translate="common_save" data-cy="common_save"></button>
    </div>
  </div>
</div>
